import type { Trend } from "../leaderboard/view/change-trend"

export function TrendDisplay({ trend }: { trend: Trend }) {
  if (trend === "neutral") return null

  return trend === "up" ? "+" : "-"
}
